<template>
    <body>
    <span class="scroolLR">Scroll LEFT/RIGHT & Choose one Category</span>
    <div class="zonescroll">
        <div class="tab" >
            <i class="fa fa-arrow-circle-left" aria-hidden="true"></i>
            <button v-for="(office) in this.offices_types" :key="office.index" v-on:mouseover="openOffice(event, office.type)">
                <img :src="office.img_source" /><br><span class="officecategory">{{office.type}}</span>
            </button>
            <i class="fa fa-arrow-circle-right" aria-hidden="true"></i>
        </div>
    </div>
    <form>
        <div class="container">
            <div style="font-size: 14px;margin-left: 5%;padding-top: 20px">Filter Offices by :
                <span style="font-weight: bold;color: orange">{{this.officeType}}</span>
            </div>
            <br>
            <div class="input-container">
                <i class="fa fa-map-marker" aria-hidden="true"></i> &nbsp;&nbsp;
                <select v-model="office" @change="configCalendar()"  style="margin-left: 9px;padding: 6px 6px">
                    <option disabled value="0" >Select Office</option>
                    <option :value="o.id" v-for="o in live_offices" :key="o.index">
                        {{o.name}} - {{o.location}}
                    </option>
                </select>&nbsp;&nbsp;
                <span style="font-size: 16px;color: yellow;font-weight:bold;font-family: 'American Typewriter';padding-top: 5px">{{countOffices}}</span>
            </div>
            <div class="input-container" v-show="checkOfficeType">
                &#128054;&nbsp;
                <div>
                    <label style="font-size: 12px;color: #fa755a">
                        <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                        Attach pet form(s)
                    </label>
                    <div v-for="pf in pet_forms" :key="pf.index" style="margin-left: 12px;font-size: 14px">
                        <input type="checkbox" v-model="pf.selected"  >
                        {{pf.name}}
                        &nbsp;&nbsp;
                        <i class="fa fa-pencil-square-o" aria-hidden="true" @click.prevent = updatePetProfile(pf.id)> edit</i>
                        &nbsp;&nbsp;
                        <i class="fa fa-trash-o" aria-hidden="true" @click.prevent = deletePetProfile(pf.id)> delete</i>

                    </div>
                </div>
                 &nbsp;&nbsp;
            </div>
            <div class="input-container" v-show="checkOfficeType">
                <button class="addpetform" @click.prevent="addNewPetProfile">
                    <i class="fa fa-plus-circle" aria-hidden="true"></i> New Pet Form
                </button>
            </div>
            <div class="input-container">
                <i class="fa fa-phone-square" aria-hidden="true"></i>
                <input type="text" placeholder="My contact..." v-model="user_contact" required>
            </div>
            <div class="input-container">
                <i class="fa fa-commenting-o" aria-hidden="true"></i>
                <input type="text" placeholder="Enter comment" v-model="user_comment" required>
            </div>
            <!-- next feature
            <div class="input-container" v-show="checkOfficeType" style="font-size: 12px;">
                <input type="checkbox" v-model="mdays"> <span style="padding-top: 5px">Multi days</span>
            </div> -->
            <div class="input-container">
                <i class="fa fa-calendar" aria-hidden="true"></i> &nbsp;&nbsp;
                <!--
                <date-picker :disabled="offCalendar" v-model:value="time_sel" type="datetime"
                             :show-time-panel="showTimeRangePanel"
                             :default-value="setDefaultDate"
                             :disabled-date="disableDateReserved"
                             :disabled-time="disableTimeReserved"
                             :time-picker-options="tpo"
                             @close="handleRangeClose"
                             placeholder="Select Date&Time">
                    <template #footer>
                        <button type="checkbox" class="mx-btn mx-btn-text" @click.prevent="toggleTimeRangePanel">
                            <span v-if="!showTimeRangePanel">&#128073;&#9201;Time</span>
                            <span v-else>&#128073;&#128198; Date</span>
                        </button>
                    </template>
                </date-picker>
                -->
                <!-- next feature -->
                <div v-if="setMultiDayCalendar" class="mdaysc">
                    <date-picker :disabled="offCalendar"
                                 v-model:value="date_range"
                                 type="date"
                                 range
                                 :default-value="setDefaultDate"
                                 :disabled-date="disableDateReserved"
                                 @close="handleRangeClose"
                                 @clear="initRange"
                                 placeholder="Select interval">
                    </date-picker>
                </div>
                <div v-else>
                    <date-picker :disabled="offCalendar"
                                 v-model:value="time_sel"
                                 type="datetime"
                                 :show-time-panel="showTimeRangePanel"
                                 :default-value="setDefaultDate"
                                 :disabled-date="disableDateReserved"
                                 :disabled-time="disableTimeReserved"
                                 :time-picker-options="tpo"
                                 @close="handleRangeClose"
                                 placeholder="Select Date&Time">
                        <template #footer>
                            <button type="checkbox" class="mx-btn mx-btn-text" @click.prevent="toggleTimeRangePanel">
                                <span v-if="!showTimeRangePanel">&#128073;&#9201;Time</span>
                                <span v-else>&#128073;&#128198; Date</span>
                            </button>
                        </template>
                    </date-picker>
                </div>
            </div>
            <button type="submit" :disabled="offMakeAppointment" @click.prevent="make_appointment">Appointment</button> &nbsp;&nbsp;
            <button type="button" class="cancelbtn" @click.prevent="goToHistory">Cancel</button>
        </div>
    </form>
    <div style="font-size: 10px;text-align: center">
        <i class="fa fa-shield" aria-hidden="true"></i> Privacy Policy :
        The User's personal contact (E-mail, Phone ...) <span style="font-weight: bold">are </span> stored on the server.
    </div>
    </body>
</template>
<script>
    import DatePicker from 'vue-datepicker-next';
    import 'vue-datepicker-next/index.css';
    import {getClientProfile} from '../hid.js'
    import {getBaseURL} from '../url_endpoints.js'
    import {ulip_post} from '../https_requests.js'
    import {get_office_types_array} from '../office_type_db.js'
    export default {
        name:'Appointment',
        components: { DatePicker },
        data() {
            return {
                baseURL : null,
                time_sel: null,
                date_range: null,
                showTimeRangePanel: false,
                user_comment:null,
                user_contact:null,
                profile :{
                    fname:null,
                    lname:null,
                    email:null,
                    hid:null,
                },
                office:null,
                offices:[],
                reservedDates:[
                    {
                        year:2022,
                        month:4,
                        day:28,
                        hours:11,
                        minutes:30
                    },
                    {
                        year:2022,
                        month:4,
                        day:28,
                        hours:10,
                        minutes:0
                    },
                    ],
                tpo:{start: '10:00', step:'00:15' , end: '12:00', format: 'HH:mm' },
                business_id:null,
                ERR_MSG:null,
                officeType:null,
                pet_forms:[
                    //{
                    //id:23,
                    //name:'bobo',
                    //}
                ],
                offices_types:get_office_types_array(),
                live_offices: [],
                mdays:false,
            };
        },
        computed: {
          offMakeAppointment() {
              //console.log(this.mdays)
              let date_selected = !this.mdays ? this.time_sel : this.date_range
              if(this.officeType === 'pet sitter') {
                  const hasPetFormAttached = this.computePetFormString()
                  //console.log('petform: '+hasPetFormAttached)
                  //console.log('dateselected: '+date_selected)
                  //console.log('office: '+this.office)
                  return (this.office > 0)&&(date_selected!= null)&&(hasPetFormAttached!=null) ? false :true
              } else {
                  return (this.office > 0)&&(date_selected!= null) ? false :true
              }
          },
            offCalendar() {
              return !this.office ? true : false
            },
            setMultiDayCalendar() {
                return (this.officeType === 'pet sitter') && (this.mdays) ? true : false
            },
            checkOfficeType() {
              if(!this.office || !this.officeType){
                  return false
              } else {
                  return (this.officeType === 'pet sitter') ? true : false
              }
            },
            countOffices() {
              return !this.live_offices ?  0 : this.live_offices.length
            },
            checkPetFormsNumber() {
              if(!this.pet_forms) return false
              return this.pet_forms.length > 1 ? true : false
            }
        },
        watch: {
            time_sel(newsel) {
                // get appointments from back-end - datatabase
                if(newsel == null) {
                    return
                }
                fetch(this.baseURL + '/appointments?office='+ this.office +
                    '&year=' +newsel.getFullYear() +
                    '&month=' + newsel.getMonth() +
                    '&day=' + newsel.getDate()).then(rsp => {
                    return rsp.json()
                }).then( response => {
                    //console.log(response)
                    this.reservedDates=[] // init array
                    for(let rdate of response) {
                        //console.log(rdate)
                        let hm = rdate.slot.split(':') // hours - minutes
                        let appointment =     {
                                year:rdate.year,
                                month:rdate.month,
                                day:rdate.day,
                                hours:hm[0],
                                minutes:hm[1]
                            }
                        this.reservedDates.push(appointment)
                    }
                    //console.log(this.reservedDates.length)
                }).catch(err => {
                    //console.log('Error when get reserved dates', err.message)
                    this.ERR_MSG = err.message
                })
            }
        },
        created() {
            //console.log('created')
            this.office = 0 // preselect office from pop-up list
            // set back-end endpoints
            this.baseURL = getBaseURL()
            // get from BackEnd the list of offices
            fetch(this.baseURL + '/offices').then(rsp => {
                return rsp.json()
            }).then( response => {
                //console.log(response)
                for(let office of response) {
                    this.offices.push(office)
                }
                this.live_offices = this.offices
            }).catch(err => {
                //console.log('Error when get offices', err)
                alert(err.message+'\nBackend Server could be down! Try again later..')
                this.$router.push('/client')
            })
        },
        mounted() {
            this.profile = getClientProfile()
            if(this.profile == null) {
                this.profile = {
                    fname:'',
                    lname:'',
                    email:'',
                    hid:'',
                }
                alert('To create appointments...\nPlease first create a profile !')
                this.$router.push('/profile')
            }
            // configure appointment form informations
            this.showTimeRangePanel = false
            // load pet profiles if exists
            const pf = localStorage.getItem('petforms')
            this.pet_forms = !pf ? this.pet_forms : JSON.parse(pf)
            // add selected field for each item
            for( let i=0;i<this.pet_forms.length ;i++) {
                this.pet_forms[i].selected = false
                //console.log(this.pet_forms[i])
            }
        },
        methods: {
            initRange(){
              this.date_range = null
            },
            openOffice(evt, oType) {
                this.officeType = oType
                // update offices list
                this.live_offices = []
                for(let o of this.offices) {
                    if(o.type === oType) {
                        this.live_offices.push(o)
                    }
                }
                // set no office selected
                this.office = 0
            },
            configCalendar() {
                //console.log('config calendar for office :' , this.office)
                // init multidays calendar
                this.mdays = false
                for(let o of this.live_offices) {
                    if(o.id === this.office) {
                        // check for multi days calendar
                        // set office Type
                        this.officeType = o.type
                        // set business id
                        this.business_id  = o.bid

                        // set multi days or time picker options
                        if(!o.slot && !o.open && !o.close ) {
                            this.mdays = true
                        }else {
                            //console.log('set time picker')
                            this.tpo = {start: o.open, step:'00:' + o.slot , end: o.close, format: 'HH:mm' }
                        }
                        break
                    }
                }
                //console.log('set mdays :'+this.mdays)
            },
            deletePetProfile(id){
                let rsp = confirm('Delete this pet form ?')
                if(!rsp) {
                    return
                }
                for(let i=0; i<this.pet_forms.length;i++){
                   if(this.pet_forms[i].id == id) {
                       this.pet_forms.splice(i,1)
                       localStorage.setItem('petforms',JSON.stringify(this.pet_forms))
                       return
                   }
                }
            },
            updatePetProfile(id){
                this.$store.commit('setPetId',id)
                this.goToPetProfile()
            },
            addNewPetProfile() {
                this.$store.commit('setPetId',null)
                this.goToPetProfile()
            },
            goToPetProfile() {
                this.$store.commit('setAppointOfficeId',this.office)
                this.$router.push('/petprofile')
            },
            goToHistory() {
                // cancel appointment
                this.$router.push('/history')
                window.scrollTo(0,0)
            },
            disableTimeReserved(date) {
                //console.log('select date :', date)
                return this.checkReservedDates(date)
            },
            disableDateReserved(date) {
                let d = new Date()
                d.setDate(d.getDate() - 1)
                return date < d
            },
            handleRangeClose() {
                this.showTimeRangePanel = false;
            },
            toggleTimeRangePanel() {
                this.showTimeRangePanel = !this.showTimeRangePanel;
            },
            setDefaultDate() {
                return Date.now()
            },
            checkReservedDates(date) {
                let timeInMiliseconds = date.getTime()
                for(let key of this.reservedDates) {
                    //console.log(key)
                    let cdate = new Date(key.year,key.month,key.day,key.hours,key.minutes)
                    //console.log(cdate)
                    let cdmiliseconds = cdate.getTime()
                    if(timeInMiliseconds === cdmiliseconds) {
                        //console.log("match time...")
                        return true
                    }
                }
                return false

            },
            computePetFormString() {
                let pform = null
                for(let key in this.pet_forms) {
                    if(this.pet_forms[key].selected) {
                        if(!pform) {
                            pform = 'pformid:'+this.pet_forms[key].id
                        }else {
                            pform = pform + '#'+this.pet_forms[key].id
                        }
                    }
                }
                return pform
            },
            make_appointment(){
                // check appointment with petform
                let pform = 'pformid:0'
                if(this.officeType === 'pet sitter') {
                    // set pet form id list
                    const petform = this.computePetFormString()
                    if(!petform) {
                        alert('Error Make Appointment!\n Cause: Pet Form not found or not attached ...')
                        return
                    }else {
                       pform = petform
                    }
                }
                // add User Profile data
                let usersays  = this.profile.fname + ' ' + this.profile.lname + ' > '
                let cm = !this.user_comment ? usersays : usersays + this.user_comment

                // time_sel is a Date object
                if(this.mdays) {
                    cm = 'Days: from ' + this.date_range[0].getDate() + ' to '+this.date_range[1].getDate() + ' ' +cm
                }
                const ct = !this.user_contact ? '' : ' Contact '+this.user_contact

                let appointment_object = {
                    hid: this.profile.hid,
                    office:this.office,
                    status:0,
                    bid:this.business_id
                }
                appointment_object.year = this.mdays ? this.date_range[0].getFullYear():this.time_sel.getFullYear()
                appointment_object.month = this.mdays ? this.date_range[0].getMonth():this.time_sel.getMonth()
                appointment_object.day = this.mdays ? this.date_range[0].getDate():this.time_sel.getDate()
                appointment_object.slot = this.mdays ? '24:00':this.time_sel.getHours() + ':' + this.time_sel.getMinutes()
                appointment_object.comment = (this.officeType === 'pet sitter') ? cm + ct + pform : cm +ct

                //create resource on the back-end  -> save new Appointment object
                ulip_post(this.baseURL,'/appointments',appointment_object).then(rsp => {
                    //console.log('New appointment saved for next slot : ' , rsp['slot'])
                    alert('New Appointment set: '+rsp['slot']+
                        '\n\nPlease read carefull the CANCELLATION rules !! \n' +
                        '\nPlease check History for appointment status...\nThanks for using SaPPo!')
                    this.$router.push('/history')
                    window.scrollTo(0,0)
                }).catch(err => {
                    alert(err.message+'\nBackend Server is not running!\n Try again later...')
                    //console.log('Error when post user appointment: ', err)
                })
            }
        }
    };
</script>
<style lang="scss" scoped>
    @import "../assets/css/my_carusel";
    body {
        font-family: Arial, Helvetica, sans-serif;
        text-align: left;
        background-color: black;
        color: white;
        height:100vh;
    }
    input[type=text]{
        width: 70%;
        padding: 6px 10px;
        margin-left: 10px;
        display: inline-block;
        border: 1px solid #ccc;
        box-sizing: border-box;

    }

    button {
        background-color: #4CAF50;
        color: white;
        padding: 10px 18px;
        margin: 8px 0;
        border: none;
        cursor: pointer;
        width: 40%;
        opacity: 0.8;
    }

    button:hover {
        opacity: 1.0;
        color: white;
    }
    button:disabled {
        background-color: darkgray;
    }

    .cancelbtn {
        width: 40%;
        padding: 10px 18px;
        background-color: #f44336;
    }

    .addpetform {
        padding: 10px 10px;
        background-color: lightseagreen;
        font-size: 12px;
        text-align: center;
        margin-left: 50px;
        width: 40%;
        border: outset;
    }

    .imgcontainer {
        text-align: center;
        margin: 24px 0 12px 0;
    }

    img.avatar {
        width: 90%;
        border-radius: 50%;
    }

    .container {
        padding: 16px 30%;
    }

    span.psw {
        float: right;
        padding-top: 16px;
    }

    a:visited {
        color: lightsalmon;
    }
    .flip-card {
        background-color: transparent;
        width: 160px;
        height: 90px;
        perspective: 1000px;
        padding-top: 10px;
        padding-left: 32%;
    }

    .flip-card-inner {
        position: relative;
        width: 100%;
        height: 100%;
        text-align:center;
        transition: transform 0.6s;
        transform-style: preserve-3d;
        box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);
    }

    .flip-card:hover .flip-card-inner {
        transform: rotateY(180deg);
    }

    .flip-card-front, .flip-card-back {
        position: absolute;
        width: 100%;
        height: 100%;
        -webkit-backface-visibility: hidden;
        backface-visibility: hidden;
    }

    .flip-card-front {
        background-color: black;
        color: black;
    }

    .flip-card-back {
        background-color: lightseagreen;
        color: white;
        transform: rotateY(180deg);
    }
    .input-container {
        display: -ms-flexbox; /* IE10 */
        display: flex;
        width: 100%;
        margin-bottom: 15px;
    }
    .scroolLR {
        margin-left: 35%;
        font-size: 11px;
        color: orange;
    }

    /* Change styles for span and  buttons on small - phones screens */
    @media screen and (max-width: 430px) {
        .container {
            padding: 16px;
        }
        .input-container {
            width: 100%;
        }
        span.psw {
            display: block;
            float: none;
        }
        button {
            width: 100%;
        }
        .cancelbtn {
            width: 100%;
        }
        .flip-card {
            width: 45%;
            padding-left: 25%;
        }
        .addpetform {
            font-size: 8px;
        }
        .input-container {
            width: 100%;
        }
        .scroolLR {
            font-size: 8px;
            margin-left: 30%;
        }
        .tab {
            width:50%
        }
        .mdaysc {
            display: flex;
            width: 100%;
        }
        body {
            height: 110vh;
        }
    }

</style>